// The NameIt! coin: the red disc with the ₦ mark, as shown in the header
// balance. Use this wherever coins are pictured so they always look the same.
const SIZES = {
  small: "w-5 h-5 text-xs",
  normal: "w-6 h-6 text-xs",
  large: "w-7 h-7 text-sm",
};

export default function NameItCoin({ size = "normal", className = "" }) {
  return (
    <span
      className={`${SIZES[size] || SIZES.normal} bg-red-600 rounded-full inline-flex items-center justify-center flex-shrink-0 text-white font-bold leading-none ${className}`}
      aria-hidden="true"
    >
      ₦
    </span>
  );
}
